'use client';

import { Skeleton } from '@/components/ui';
import { motion } from '@/libs';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3 },
  },
};

export const SkeletonLuckySequence = () => {
  return (
    <motion.div
      className="flex flex-col w-full"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        variants={itemVariants}
        className="flex rounded-full bg-foreground/10 m-4 w-72 mx-auto"
      >
        <Skeleton className="h-8 w-1/2 rounded-full" />
        <Skeleton className="h-8 w-1/2 rounded-full" />
      </motion.div>

      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 mb-4 px-6"
        variants={containerVariants}
      >
        {Array.from({ length: 24 }).map((_, index) => (
          <motion.div key={index} variants={itemVariants} className="w-full">
            <Skeleton className="h-8 w-full rounded-lg border-dotted border-2 !border-foreground/25 bg-foreground/15" />
          </motion.div>
        ))}
      </motion.div>

      <motion.div
        variants={itemVariants}
        className="flex items-center justify-end gap-2 px-6 pb-4"
      >
        <Skeleton className="h-8 w-8 rounded" />
        <Skeleton className="h-8 w-8 rounded" />
        <Skeleton className="h-8 w-8 rounded" />
        <Skeleton className="h-8 w-8 rounded" />
        <Skeleton className="h-8 w-8 rounded" />
        <Skeleton className="h-8 w-8 rounded" />
      </motion.div>
    </motion.div>
  );
};
